import type { QuestionOption } from '../../types';

// ---------------------------------------------------------------------------
// Shared option lists + conditions for the MHMF (habitational / manufactured
// housing) supplement family.
// ---------------------------------------------------------------------------

/** Both habitational AND manufactured housing flows */
export const HAB_MH_CONDITION = [
  {
    field: 'industry_type',
    operator: 'in' as const,
    value: ['habitational', 'manufactured_housing'],
  },
];

/** US states as select options (for use inside repeating-group rows) */
export const US_STATE_OPTIONS: QuestionOption[] = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
  'DC',
].map((s) => ({ label: s, value: s }));

/** Lines of coverage as they appear in the MHMF loss-runs checklist */
export const LOSS_RUN_LINE_OPTIONS: QuestionOption[] = [
  { label: 'Property', value: 'property' },
  { label: 'General Liability', value: 'general_liability' },
  { label: 'Umbrella / Excess', value: 'umbrella' },
  { label: 'EPLI', value: 'epli' },
  { label: 'Workers Comp', value: 'workers_comp' },
  { label: 'Auto', value: 'auto' },
  { label: 'Equipment Breakdown', value: 'equipment_breakdown' },
  { label: 'Cyber', value: 'cyber' },
  { label: 'Crime / Fidelity', value: 'crime' },
  { label: 'Environmental / Pollution', value: 'environmental' },
  { label: 'Flood', value: 'flood' },
  { label: 'Earthquake', value: 'earthquake' },
  { label: 'Builders Risk', value: 'builders_risk' },
  { label: 'Other', value: 'other' },
];
